// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-94508a96]{margin-top:24px}p[data-v-94508a96]{display:flex;align-items:center}p label[data-v-94508a96]{display:block;margin-right:10px}.multiselect[data-v-94508a96]{flex-grow:1;max-width:300px}\n", ""]);
// Exports
module.exports = exports;
